import { unstable_generateUtilityClasses, unstable_generateUtilityClass } from '@mui/utils';

// reference: https://github.com/mui/material-ui/blob/master/packages/mui-joy/src/className/index.ts
const generateUtilityClass = (componentName, slot) => unstable_generateUtilityClass(componentName, slot, 'Mui');
const generateUtilityClasses = (componentName, slots) => unstable_generateUtilityClasses(componentName, slots, 'Mui');
function getLogoUtilityClass(slot) {
  return generateUtilityClass('HublaLogo', slot);
}
generateUtilityClasses('HublaLogo', ['root']);

export { getLogoUtilityClass };
